import {
  ActionsCell, GestionarButton, SubsanarButton, VerButton, HistorialButton,
} from "../ui/table.styles";
import { EN_PROCESO_GESTION_ID, EN_SUBSANACION_GESTION_ID, formatDate, renderPill, wrapCell, wrapTitle } from "./alertManagementConstants";

export const getAlertManagementColumns = ({
  alertManagementPillMap,
  canGestionar,
  canSubsanar,
  canVerHistorial,
  onGestionar,
  onSubsanar,
  onVer,
  onHistorial,
}) => [
  { title: wrapTitle("Fecha", "solicitud"), dataIndex: "fechaSolicitud", key: "fechaSolicitud", width: 150, align: "center", render: formatDate },
  { title: wrapTitle("ID", "solicitud"), dataIndex: "idEncabezado", key: "idEncabezado", width: 120, align: "center", render: (v) => v || "—" },
  { title: wrapTitle("Tipo de", "gestión"), dataIndex: "tipoGestion", key: "tipoGestion", width: 160, align: "center", ...wrapCell },
  {
    title: wrapTitle("Gestión", "alerta"), dataIndex: "gestionAlerta", key: "gestionAlerta",
    width: 160, align: "center",
    render: (v, r) => renderPill(v, r?.gestionAlertaCodigo, alertManagementPillMap),
  },
  { title: "Observación", dataIndex: "observacion", key: "observacion", width: 250, align: "center", render: (v) => v || "—", ...wrapCell },
  {
    title: "Acciones", key: "actions", width: 300, align: "center", fixed: "right",
    render: (_, record) => {
      const isEnSubsanacion = Number(record?.gestionAlertaCodigo) === EN_SUBSANACION_GESTION_ID;
      const isEnProceso     = Number(record?.gestionAlertaCodigo) === EN_PROCESO_GESTION_ID;
      return (
        <ActionsCell>
          {canGestionar && <GestionarButton disabled={!isEnProceso} onClick={() => onGestionar(record)}>Gestionar</GestionarButton>}
          {canSubsanar && isEnSubsanacion && <SubsanarButton onClick={() => onSubsanar(record)}>Subsanar</SubsanarButton>}
          {canVerHistorial && <VerButton onClick={() => onVer(record)}>Ver</VerButton>}
          {canVerHistorial && <HistorialButton onClick={() => onHistorial(record)}>Historial</HistorialButton>}
        </ActionsCell>
      );
    },
  },
];